import React, {useEffect, useState} from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {GalleryOutlineIcon, PlaceholderIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {ImageStatus, imageValidation, ValidationResponse} from "../../helpers/quick_view/image_validation";

export type GalleryType = "photo" | "plan";

interface IProps {
    alt: string;
    firstImageSrc: string;
    secondImageSrc: string;
    propertyLink: string;
    clickEvent?: (type: GalleryType) => void;
    className?: string;
    textInButtonsDisabled?: boolean;
    buttonClassName?: string;
}

export const QWImageWithButton = (props: IProps) => {
    const {alt, firstImageSrc, secondImageSrc, clickEvent} = props;
    const [imgStatus, setImageStatus] = useState(ImageStatus.LOADING);
    const [currentSrc, setCurrentSrc] = useState(firstImageSrc);
    const isMobile = useUserDevice();
    const target = useResponsiveLinkTarget();

    useEffect(() => {
        setCurrentSrc(firstImageSrc);
    }, [firstImageSrc]);

    // image validation
    useEffect(() => {
        imageValidation(currentSrc)
            .then((res) => setImageStatus(res.status))
            .catch((err: ValidationResponse) => setImageStatus(err.status));
    }, [currentSrc]);

    const handleImageClick = () => {
        currentSrc === firstImageSrc ? setCurrentSrc(secondImageSrc) : setCurrentSrc(firstImageSrc);
        clickEvent?.(currentSrc === firstImageSrc ? "photo" : "plan");
    };

    const getButtonText = () => {
        if (props.textInButtonsDisabled) {
            return "";
        }
        if (currentSrc === secondImageSrc) {
            return "rzut";
        }
        return "zdjęcie";
    };

    const Icon = firstImageSrc === currentSrc ? GalleryOutlineIcon : PropertyPlanIcon;

    switch (imgStatus) {
        case ImageStatus.SUCCESS:
            return (
                <div css={QWDataWrapper} className={props.className}>
                    <a href={props.propertyLink} target={target} css={imageWrapper}>
                        <Image alt={alt} width="650px" height="365px" ratio={{xs: "650/365"}} src={currentSrc} />
                    </a>

                    <Button
                        onClick={handleImageClick}
                        className={props.buttonClassName}
                        css={[positionButton]}
                        iconLeft={(iconProps) => <Icon {...iconProps} size={props.textInButtonsDisabled ? "1.6" : iconProps.size} />}
                        variant="filled_primary"
                        size="x-small"
                    >
                        {getButtonText()}
                    </Button>
                </div>
            );
        case ImageStatus.LOADING:
            return (
                <div css={loaderContainer}>
                    <Loader />
                </div>
            );
        case ImageStatus.ERROR:
        default:
            return (
                <div css={blankPlanImage}>
                    <PlaceholderIcon size={isMobile ? "8" : "12"} />
                </div>
            );
    }
};

const loaderContainer = css`
    width: 100%;
    height: 25rem;
    ${flexAbsoluteCenter};
`;

const QWDataWrapper = css`
    background-color: #fff;
    cursor: pointer;
    max-width: 100%;
    text-align: center;
    position: relative;
`;

const imageWrapper = css`
    display: block;
    max-width: 650px;
    margin: 0 auto;
`;

const blankPlanImage = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.gray[400]};
    width: 100vw;
    height: 20rem;
    margin-left: -${calculateRemSize(1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        margin-right: 2.5rem;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        border-radius: 0.4rem;
        margin-left: initial;
        width: 100%;
        height: 36.5rem;
    }

    ::selection {
        background-color: transparent;
    }
`;

const positionButton = css`
    position: absolute;
    left: 1.6rem;
    bottom: 1.6rem;
`;
import React, {useEffect, useState} from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {GalleryOutlineIcon, PlaceholderIcon, PropertyPlanIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {ImageStatus, imageValidation, ValidationResponse} from "../../helpers/quick_view/image_validation";

export type GalleryType = "photo" | "plan";

interface IProps {
    alt: string;
    firstImageSrc: string;
    secondImageSrc: string;
    propertyLink: string;
    clickEvent?: (type: GalleryType) => void;
    className?: string;
    textInButtonsDisabled?: boolean;
    buttonClassName?: string;
}

export const QWImageWithButton = (props: IProps) => {
    const {alt, firstImageSrc, secondImageSrc, clickEvent} = props;
    const [imgStatus, setImageStatus] = useState(ImageStatus.LOADING);
    const [currentSrc, setCurrentSrc] = useState(firstImageSrc);
    const isMobile = useUserDevice();
    const target = useResponsiveLinkTarget();

    useEffect(() => {
        setCurrentSrc(firstImageSrc);
    }, [firstImageSrc]);

    // image validation
    useEffect(() => {
        imageValidation(currentSrc)
            .then((res) => setImageStatus(res.status))
            .catch((err: ValidationResponse) => setImageStatus(err.status));
    }, [currentSrc]);

    const handleImageClick = () => {
        currentSrc === firstImageSrc ? setCurrentSrc(secondImageSrc) : setCurrentSrc(firstImageSrc);
        clickEvent?.(currentSrc === firstImageSrc ? "photo" : "plan");
    };

    const getButtonText = () => {
        if (props.textInButtonsDisabled) {
            return "";
        }
        if (currentSrc === secondImageSrc) {
            return "rzut";
        }
        return "zdjęcie";
    };

    const Icon = firstImageSrc === currentSrc ? GalleryOutlineIcon : PropertyPlanIcon;

    switch (imgStatus) {
        case ImageStatus.SUCCESS:
            return (
                <div css={QWDataWrapper} className={props.className}>
                    <a href={props.propertyLink} target={target} css={imageWrapper}>
                        <Image alt={alt} width="650px" height="365px" ratio={{xs: "650/365"}} src={currentSrc} />
                    </a>

                    <Button
                        onClick={handleImageClick}
                        className={props.buttonClassName}
                        css={[positionButton]}
                        iconLeft={(iconProps) => <Icon {...iconProps} size={props.textInButtonsDisabled ? "1.6" : iconProps.size} />}
                        variant="filled_primary"
                        size="x-small"
                    >
                        {getButtonText()}
                    </Button>
                </div>
            );
        case ImageStatus.LOADING:
            return (
                <div css={loaderContainer}>
                    <Loader />
                </div>
            );
        case ImageStatus.ERROR:
        default:
            return (
                <div css={blankPlanImage}>
                    <PlaceholderIcon size={isMobile ? "8" : "12"} />
                </div>
            );
    }
};

const loaderContainer = css`
    width: 100%;
    height: 25rem;
    ${flexAbsoluteCenter};
`;

const QWDataWrapper = css`
    background-color: #fff;
    cursor: pointer;
    max-width: 100%;
    text-align: center;
    position: relative;
`;

const imageWrapper = css`
    display: block;
    max-width: 650px;
    margin: 0 auto;
`;

const blankPlanImage = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.gray[400]};
    width: 100vw;
    height: 20rem;
    margin-left: -${calculateRemSize(1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        margin-right: 2.5rem;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        border-radius: 0.4rem;
        margin-left: initial;
        width: 100%;
        height: 36.5rem;
    }

    ::selection {
        background-color: transparent;
    }
`;

const positionButton = css`
    position: absolute;
    left: 1.6rem;
    bottom: 1.6rem;
`;
